'use client';

import * as React from 'react';
import { cn } from '@/core/lib/utils';
import { Radio } from './Radio';

export interface RadioGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: string;
  onValueChange?: (value: string) => void;
  options: Array<{
    value: string;
    label: string;
    disabled?: boolean;
  }>;
  orientation?: 'horizontal' | 'vertical';
  name?: string;
}

const RadioGroup = React.forwardRef<HTMLDivElement, RadioGroupProps>(
  (
    {
      className,
      value,
      onValueChange,
      options,
      orientation = 'vertical',
      name,
      ...props
    },
    ref
  ) => {
    const handleChange = (optionValue: string) => {
      onValueChange?.(optionValue);
    };

    return (
      <div
        ref={ref}
        className={cn(
          'flex gap-4',
          orientation === 'horizontal' ? 'flex-row' : 'flex-col',
          className
        )}
        data-pte-name='radio-group'
        {...props}
      >
        {options.map((option, index) => (
          <Radio
            key={option.value}
            id={`radio-${option.value}`}
            value={option.value}
            checked={value === option.value}
            onChange={() => handleChange(option.value)}
            disabled={option.disabled}
            label={option.label}
            name={name}
            data-pte-name={`radio-group-item-${index}`}
          />
        ))}
      </div>
    );
  }
);

RadioGroup.displayName = 'RadioGroup';

export { RadioGroup };
